import createRetained from "@repo/signals/createRetained";

import Expand from "../animation/Expand";
import Fade from "../animation/Fade";

namespace Input {
  export type Error = boolean | string | globalThis.Error;

  export declare namespace Error {
    type Props = {
      class?: string;
      children: Error | undefined;
    };
  }

  export function Error({ children }: D<Error.Props>) {
    const message = () => {
      const e = children;
      return (
        !!e && e !== true && (e instanceof globalThis.Error ? e.message : e)
      );
    };
    const retained = createRetained(message);

    return (
      <Expand direction="y" show={message()}>
        <Fade
          show={message()}
          transition="var(--normal-s) calc(var(--normal-s) / 2)"
        >
          <div class="text:small px-1 pt-0.5 color:error border-box">
            {retained()}
          </div>
        </Fade>
      </Expand>
    );
  }
}

export default Input;
